import { render, staticRenderFns } from "./CustomFontPicker.vue?vue&type=template&id=4db2f80e&"
import script from "./CustomFontPicker.vue?vue&type=script&lang=js&"
export * from "./CustomFontPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports